import {FC, useState} from "react";
import {Form, FormProps, Input, message, Modal} from "antd";
import {EventRequestVatrusPost} from "../../../../types/domain.ts";
import {eventsEventIdRequestVatrusPost} from "../../../../api/events/eventsEventIdRequestVatrusPost.ts";

type Props = {
    eventId: string;
    open: boolean;
    onClose: VoidFunction;
}

export const RequestVatrusModal: FC<Props> = ({ eventId, open, onClose }) => {
    const [form] = Form.useForm<EventRequestVatrusPost>();
    const [loading, setLoading] = useState(false);

    const handleFinish: FormProps<EventRequestVatrusPost>['onFinish'] = (values) => {
        setLoading(true);
        eventsEventIdRequestVatrusPost(eventId, values).then(() => {
            void message.success('Запрос отправлен');
        }).catch((e) => {
            void message.error(`Произошла ошибка при добавлении пользователя (${JSON.stringify(e)})`);
            console.error(e);
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <Modal
            open={open}
            onOk={form.submit}
            okButtonProps={{ loading }}
            onCancel={onClose}
            title="Запросить публикацию на VATRUS"
            destroyOnClose
        >
            <Form<EventRequestVatrusPost>
                form={form}
                onFinish={handleFinish}
                layout="vertical"
                preserve={false}
            >
                <Form.Item<EventRequestVatrusPost>
                    label="Ссылка на новость на VATRUS"
                    name="vatrus_href"
                    rules={[{ required: true, pattern: /vatrus\.info/, message: 'Невалидная ссылка' }]}
                >
                    <Input placeholder="https://vatrus.info/news/****" />
                </Form.Item>
            </Form>
        </Modal>
    )
}